/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AntiforgeryTokenResponse } from '../models/AntiforgeryTokenResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InfrastructureService {
    /**
     * @returns AntiforgeryTokenResponse OK
     * @throws ApiError
     */
    public static getAntiforgeryToken(): CancelablePromise<AntiforgeryTokenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/antiforgery-token',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static logout(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/logout',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
